import { forwardRef } from 'react';
import clsx from 'clsx';

const Input = forwardRef(
  (
    {
      label,
      error,
      helperText,
      type = 'text',
      fullWidth = false,
      className = '',
      containerClassName = '',
      ...props
    },
    ref
  ) => {
    const inputClasses = clsx(
      'px-4 py-2 border rounded-lg transition-colors duration-200',
      'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent',
      'disabled:bg-gray-100 disabled:cursor-not-allowed',
      error
        ? 'border-secondary-500 focus:ring-secondary-500'
        : 'border-gray-300',
      'bg-white text-primary-900',
      'placeholder:text-gray-400',
      fullWidth && 'w-full',
      className
    );

    return (
      <div className={clsx('flex flex-col', fullWidth && 'w-full', containerClassName)}>
        {label && (
          <label className="mb-1.5 text-sm font-medium text-primary-700">
            {label}
          </label>
        )}
        
        <input ref={ref} type={type} className={inputClasses} {...props} />
        
        {(error || helperText) && (
          <p
            className={clsx(
              'mt-1.5 text-sm',
              error ? 'text-secondary-500' : 'text-gray-600'
            )}
          >
            {error || helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
